import { Directive, Input, HostListener } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';

@Directive({
  selector: '[appOpenDatepickerOnClick]',
  standalone: false
})
export class OpenDatepickerOnClickDirective {
  @Input('appOpenDatepickerOnClick') datepicker?: MatDatepicker<any>;

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    if (this.datepicker) {
      this.datepicker.open();
      event.stopPropagation();
    }
  }
}
